const oneMinuteInSecs = 60;
const tenSecs = 10;
const oneHourInSecs = oneMinuteInSecs * 60;
export const time = {
  oneDayInSecs: oneHourInSecs * 24,
  oneHourInSecs,
  tenMinutesInSecs: 10 * oneMinuteInSecs,
  tenSecs,
};
